// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.trustmanagement

import org.multipaz.cbor.DataItem
import org.multipaz.trustmanagement.TrustEntryVical
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.trustmanagement.TrustMetadata
import org.multipaz.cbor.Bstr
import org.multipaz.trustmanagement.toDataItem
import org.multipaz.trustmanagement.fromDataItem

fun TrustEntryVical.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "1AOF1TW4735VZnXFLvR36hQi3D5fgMMTVmKtBKaE6rE")
val TrustEntryVical_cborSchemaId = ByteString(-44, 3, -123, -43, 53, -72, -17, 126, 85, 102, 117, -59, 46, -12, 119, -22, 20, 34, -36, 62, 95, -128, -61, 19, 86, 98, -83, 4, -90, -124, -22, -79)

fun TrustEntryVical.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Vical")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("metadata", this.metadata.toDataItem())
    builder.put("encodedSignedVical", Bstr(this.encodedSignedVical.toByteArray()))
    return builder.end().build()
}

fun TrustEntryVical_fromDataItem(dataItem: DataItem): TrustEntryVical {
    val identifier = dataItem["identifier"].asTstr
    val metadata = TrustMetadata.fromDataItem(dataItem["metadata"])
    val encodedSignedVical = ByteString(dataItem["encodedSignedVical"].asBstr)
    return TrustEntryVical(
        identifier = identifier,
        metadata = metadata,
        encodedSignedVical = encodedSignedVical,
    )
}
